module.exports = __webpack_public_path__ + "img/poly-7.504c1fcc.png";